// extracted by mini-css-extract-plugin
export var contact = "Footer-module--contact--9EV2m";
export var container = "Footer-module--container--Zudck";
export var copyright = "Footer-module--copyright--PLESF";
export var footer = "Footer-module--footer--s9rIp";
export var menu = "Footer-module--menu--hcHQP";
export var social = "Footer-module--social--nGVvn";
export var terms = "Footer-module--terms--zgbAk";